module.exports = __webpack_public_path__ + "static/media/Facilities Rec.8ff499cd.jpg";